import { requestActions } from "./utils";

export const CONFIRMATION_INFO = requestActions("Auth/Confirmation/Info");
export const CONFIRMATION_SUBMIT = requestActions("Auth/Confirmation/Submit");
